import { ClaudeConnectorGuide } from '@/components/integrations/claude-connector/claude-connector-guide';
import { Layout, PageContent, PageHeader, PageLayout } from '@/components/ui/design-system';
import { useTranslation } from '@/hooks/use-translation';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/integrations/claude-connector')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('desktop_ui');
  const navigate = useNavigate();

  return (
    <PageLayout>
      <PageHeader
        parent={{
          label: t('settings.sidebar.integrations'),
          onClick: () => navigate({ to: '/settings/integrations' }),
        }}
        title="Claude"
      />
      <PageContent>
        <Layout isScrollable>
          <ClaudeConnectorGuide />
        </Layout>
      </PageContent>
    </PageLayout>
  );
}
